import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import './HorizontalFooter.scss';
import Heading from '../../Atoms/Heading/Heading';
import Link from '../../Atoms/Link/Link';
import { FooterComponentsProps, NavigationSectionItem } from '../../Interfaces/FooterInterface';
import classNames from 'classnames';
import { getHoriFooterHrefAttr, isCookieLink } from '../../Templates/Footer/Util';

const HorizontalFooter: React.FC<FooterComponentsProps> = ({ apiData, analyticsHandler, testAutoId }) => {
  const navigationSections = _get(apiData, ['navigationSections'], []);
  const navigationColumns =
    !_isEmpty(navigationSections) &&
    _get(navigationSections, ['0', 'navigationSectionItems']).map((link: NavigationSectionItem) => {
      const linkClassnames = classNames('horizontal-footer__link', { 'optanon-toggle-display': isCookieLink(link) });
      const hrefAttribute = getHoriFooterHrefAttr(link);
      const title = _get(link, ['alternateText'], '');
      return (
      <>
        <li className="horizontal-footer__item" key={_get(link, ['title'], '')}>
          <Link
            text={title}
            href={hrefAttribute}
            className={linkClassnames}
            onClick={() => analyticsHandler(_get(link, ['analyticsText'], ''))}
          />
        </li>
        <Heading className="horizontal-footer__separator" level="span" title={'|'}></Heading>
      </>
    )});

  return (
    <div className="horizontal-footer__container" data-testid={testAutoId}>
      <ul className="horizontal-footer__links">{navigationColumns}</ul>
    </div>
  );
};

export default HorizontalFooter;
